export default __webpack_public_path__ + "static/media/SraddhaResume.a5ee2d93.pdf";